import React from "react";
import { Container } from "../../../components";
import InformationBlocks from "./InformationBlocks";

const ApprovalReceipt: React.FC = () => (
    <div className="consent-landing-page">
        <Container size="medium">
            <section>
                <InformationBlocks.OrderCompleted />
            </section>
        </Container>
    </div>
);

export default ApprovalReceipt;
